import React, { Fragment, useEffect } from "react";
import Header from "../../Header/Header";
import PageTitle from "../../pagetitle/PageTitle";
import Footer from "../../footer/Footer";
import Scrollbar from "../../scrollbar/scrollbar";
import AiIntegration from "./AiIntegration";


const AiIntegrationsinglepage: React.FC = () => {
    useEffect(() => {
        document.title = "AI Integration | Brain Machine AI";
      }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                    <PageTitle pageTitle="AI Integration" pagesub=" AI Integration" />
                       <AiIntegration></AiIntegration>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default AiIntegrationsinglepage;
